var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-between"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.notify.title)+" ")]),_c('div',{staticClass:"time mr10"},[_vm._v(" "+_vm._s(_vm.notify.createdTime[0])+" ")])]),_c('div',{staticClass:"line mt20"})])
}
var staticRenderFns = []

export { render, staticRenderFns }